import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsLoadingLimitsRoute: InvariantJiraRoute = {
	name: 'arj-settings-loading-limits',
	path: '/jira/plans/settings/loading-limits',
};
